import { CircleLoader } from "../../components/CircleLoader";
import { BiBookBookmark } from "react-icons/bi";

export const EditClassForm = ({
  form,
  handleChange,
  handleSubmit,
  isLoading,
  onClose,
}: any) => {
  return (
    <form onSubmit={handleSubmit} className="p-6 max-w-lg mx-auto">
      <div className="space-y-5">
        <div>
          <label className="flex items-center gap-2 text-xs font-bold text-slate-700 uppercase tracking-wider mb-2">
            <BiBookBookmark size={16} className="text-[#0096D1]" />
            Classroom Name
          </label>
          <input
            type="text"
            placeholder="e.g. JSS 1 Green, Creches, Primary 2..."
            name="name"
            value={form.name || ""}
            onChange={handleChange}
            required
            className="w-full px-4 py-3 rounded-xl border border-slate-200 bg-slate-50/60 text-slate-800 text-sm font-medium placeholder-slate-400 focus:outline-none focus:bg-white focus:border-[#0096D1] focus:ring-4 focus:ring-[#0096D1]/10 transition-all shadow-sm"
          />
          <p className="text-[11px] text-slate-400 mt-1.5">
            This name will be visible across report sheets, attendance, and student profiles.
          </p>
        </div>

        {/* Assessment Mode Configuration */}
        <div>
          <label className="flex items-center gap-2 text-xs font-bold text-slate-700 uppercase tracking-wider mb-2">
            Assessment & Grading Mode
          </label>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <button
              type="button"
              onClick={() => {
                handleChange({
                  target: { name: "assessment_mode", value: "standard_matrix" },
                });
              }}
              className={`p-3.5 rounded-xl border-2 text-left transition-all ${
                form.assessment_mode !== "traits_only" && form.assessment_type !== "traits_only"
                  ? "border-[#0096D1] bg-sky-50/50 shadow-xs"
                  : "border-slate-200 bg-white hover:bg-slate-50 opacity-80"
              }`}
            >
              <div className="flex items-center gap-2 mb-1">
                <span className="text-sm font-bold text-slate-800">
                  Standard Matrix
                </span>
                {form.assessment_mode !== "traits_only" && form.assessment_type !== "traits_only" && (
                  <span className="text-[10px] font-bold bg-[#0096D1] text-white px-1.5 py-0.5 rounded">
                    Active
                  </span>
                )}
              </div>
              <p className="text-[11px] text-slate-500 leading-snug">
                Full academic subjects, continuous assessment (CA), exam scores, and behavioural ratings.
              </p>
            </button>

            <button
              type="button"
              onClick={() => {
                handleChange({
                  target: { name: "assessment_mode", value: "traits_only" },
                });
              }}
              className={`p-3.5 rounded-xl border-2 text-left transition-all ${
                form.assessment_mode === "traits_only" || form.assessment_type === "traits_only"
                  ? "border-amber-500 bg-amber-50/60 shadow-xs"
                  : "border-slate-200 bg-white hover:bg-slate-50 opacity-80"
              }`}
            >
              <div className="flex items-center gap-2 mb-1">
                <span className="text-sm font-bold text-slate-800">
                  Traits Only
                </span>
                {(form.assessment_mode === "traits_only" || form.assessment_type === "traits_only") && (
                  <span className="text-[10px] font-bold bg-amber-500 text-white px-1.5 py-0.5 rounded">
                    Active
                  </span>
                )}
              </div>
              <p className="text-[11px] text-slate-500 leading-snug">
                Early years, creche, and nursery: observational traits, milestones, and remarks only (no subject exams).
              </p>
            </button>
          </div>
        </div>

        <div className="flex items-center justify-end gap-3 pt-4 border-t border-slate-100">
          {onClose && (
            <button
              type="button"
              onClick={onClose}
              className="px-5 py-2.5 rounded-xl border border-slate-200 text-slate-600 font-bold text-xs hover:bg-slate-50 hover:text-slate-800 transition-all"
            >
              Cancel
            </button>
          )}
          <button
            type="submit"
            disabled={isLoading}
            className="px-6 py-2.5 rounded-xl bg-[#0096D1] hover:bg-[#0085ba] text-white font-bold text-xs shadow-sm hover:shadow transition-all disabled:opacity-50 flex items-center gap-2"
          >
            {isLoading ? (
              <>
                <CircleLoader />
                <span>Saving...</span>
              </>
            ) : (
              "Save Changes"
            )}
          </button>
        </div>
      </div>
    </form>
  );
};
